import { red } from 'apollo-react/colors';
import FileInput from 'apollo-react/components/FileInput';
import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import Upload from 'apollo-react-icons/Upload';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import HyperLink from './ssHyperLink/HyperLinkComponent';
import { uploadFile } from '../../actions/FileUploadActions';
import FileLoading from '../../components/FileLoading';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getAppSettingsByKey } from '../../selectors/AppConfigsSelectors';
import { getUITA, isFileTypeAllowed, transformFileFormatsToAccept } from '../../utils/commonUtils';
import { getFormEntityKey } from '../selectors/common.selectors';

const SSFileInput = ({
  label,
  isRequired,
  error,
  instanceId,
  entityName,
  fieldName,
  isEditor,
  isDetail,
  isViewOnly,
  actions,
  disabled,
}) => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const supportedFileExtensions = useSelector(
    getAppSettingsByKey('Attachments/SupportedFileExtensions')
  );

  const [upload, setUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [fileFormatError, setFileFormatError] = useState(false);

  const entityKey = useFormSelector(getFormEntityKey);

  const { isMobileDevice } = useWindowDimensions();

  const setUploadValue = (upload = {}) => {
    const value = upload.ACO_ID;
    const fileName = upload.ACO_FILE_NAME;
    actions.updateControlValue(value);

    setUpload({
      id: value,
      name: fileName,
    });
  };

  const handleFileUpload = async (file) => {
    if (!isFileTypeAllowed(supportedFileExtensions, file)) {
      setFileFormatError(true);
      return;
    }

    setFileFormatError(false);
    setUploading(true);
    const upload = await dispatch(uploadFile(file));

    setUploadValue(upload);
    setUploading(false);
  };

  if (isDetail) {
    return;
  }

  if (isEditor) {
    return (
      <div style={{ display: 'flex' }}>
        <Typography style={{ marginRight: 15 }}>{label || 'ssFileInput'}</Typography>
        <Upload color="primary" />
      </div>
    );
  }

  return (
    <Grid container ui-ta={getUITA('FormCtrl', 'SSFileInput', entityName, fieldName)}>
      <Grid item xs={isMobileDevice ? 12 : null}>
        <FileInput
          id={instanceId}
          style={{ width: 568 }}
          label={label}
          onChange={handleFileUpload}
          buttonText={translateString('Browse')}
          placeholder={translateString('File Path')}
          disabled={isEditor || isViewOnly || disabled}
          required={isRequired}
          error={error || fileFormatError}
          accept={transformFileFormatsToAccept(supportedFileExtensions)}
        />
      </Grid>
      {fileFormatError && (
        <Grid item xs={12}>
          <Typography variant="caption" style={{ color: red }}>
            {translateString('File will not be uploaded. Extension is not supported')}
          </Typography>
        </Grid>
      )}
      {uploading && <FileLoading />}
      {!uploading && upload && (
        <Grid item xs={12}>
          <HyperLink
            pathname="AttachmentView.aspx"
            queryString={`entityKey=${entityKey}&tempAttachmentId=${upload.id}`}
            text={upload.name}
            hasIcon={false}
            isAttachmentLink
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SSFileInput;
